export enum TagSize {
  medium = 'medium',
  large = 'large',
}

export enum TagVariant {
  normal = 'normal',
  oncolor = 'oncolor',
  emphasised = 'emphasised',
}
